// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3BWGz","content":"styles_content__3nTIw","selectAll":"styles_selectAll__1bJ7m"};